import axios from 'axios';
import config from '../config/config';

const baseURL = config.SERVER_BASE_URL;

const axiosInstance = axios.create({
  baseURL,
  headers: {Accept: 'application/json'},
});
    
export {axiosInstance};


